import { create, } from "zustand";
import { devtools, persist, createJSONStorage } from "zustand/middleware";
import sync from "zustand-sync-middleware";

const storageUnit = localStorage;
const persistanceKey = "benefit-plan-storage";

//TODO 
const dynamoDBStorage = {
    getItem: async (name) => {
        console.log(name, 'has been retrieved')
        // return (await get(name)) || null
    },
    setItem: async (name, value) => {
        console.log(name, 'with value', value, 'has been saved')
        // await set(name, value)
    },
    removeItem: async (name) => {
        console.log(name, 'has been deleted')
        // await del(name)
    },

};

const persistOptions = {
    name: persistanceKey,
    storage: createJSONStorage(() => storageUnit),
    // partialize: (state) => ({
    //     count: state.count,
    //     name: state.name,
    // }),
}
const syncOptions = {
    name: persistanceKey,
    enabled: storageUnit === localStorage,
}

const multiStepFormPersistanceKey = "bntf-plan-multi-step-form-storage";

const multiStepFormPersistOptions = {
    name: multiStepFormPersistanceKey,
    storage: createJSONStorage(() => storageUnit), //TODO dynamoDBStorage
    // storage: createJSONStorage(() => dynamoDBStorage),
    // partialize: (state) => ({
    //     count: state.count,
    //     name: state.name,
    // }),
}

const multiStepFormStoreSyncOptions = {
    name: multiStepFormPersistanceKey,
    enabled: storageUnit === localStorage,
}

const useBenefitPlanStore = create(
    devtools(
        persist(
            sync(
                (set, get) => ({
                    activeDraftId: '',
                    benefitPlans: [
                        // {
                        //     draftId: '',
                        //     benefitPlanName: '',
                        //     benefitPlanComponents: [],
                        // }
                    ],
                    chosenBenefitPlanRiders: [],
                    getActiveBenefitPlanDraft: () => get().benefitPlans?.find((bp) => bp.draftId == get().activeDraftId),
                    addBenefitPlan: ({ draftId, benefitPlanName, ...rest }) =>
                        set((state) => {
                            return {
                                ...state,
                                activeDraftId: draftId,
                                benefitPlans: [...state.benefitPlans, { draftId, benefitPlanName, benefitPlanComponents: [], chosenBenefitPlanRiders: [], ...rest }],
                            };
                        }),
                    removeBenefitPlan: ({ draftId }) => set((state) => {
                        return {
                            ...state,
                            activeDraftId: null,
                            benefitPlans: state.benefitPlans.filter(bp => bp.draftId !== draftId),
                        };
                    }),
                    setActiveBenefitPlan: ({ draftId }) =>
                        set((state) => {
                            return { activeDraftId: draftId };
                        }),
                    // setBenefitPlanName: ({ draftId, benefitPlanName }) => set((state) => {

                    //     const updatedBenefitPlans = state.benefitPlans.map(obj => {
                    //         if (obj.draftId === draftId) {
                    //             return { benefitPlanName, ...obj };
                    //         }
                    //         return obj;
                    //     });

                    //     if (!updatedBenefitPlans?.length) {
                    //         return { ...state, activeDraftId: draftId, benefitPlans: [{ draftId, benefitPlanName, benefitPlanComponents: [] }] }
                    //     }

                    //     return state
                    // }),

                    //compoent
                    addBenefitPlanCompoent: ({ draftId, benefitPlanComponent }) =>
                        set((state) => {
                            const updatedBenefitPlans = state.benefitPlans.map((obj) => {
                                if (obj.draftId === draftId) {
                                    const isIncluded = obj.benefitPlanComponents?.some(
                                        (bpc) => bpc.bnftPlanCompHistFactKey === benefitPlanComponent.bnftPlanCompHistFactKey && bpc.benefitPlanCompKey === benefitPlanComponent.benefitPlanCompKey
                                    );
                                    if (isIncluded) {
                                        return obj;
                                    }
                                    return { ...obj, benefitPlanComponents: [...obj.benefitPlanComponents, benefitPlanComponent] };
                                }
                                return obj;
                            });
                            return { ...state, benefitPlans: updatedBenefitPlans };
                        }),
                    removeBenefitPlanCompoent: ({ draftId, benefitPlanComponent }) =>
                        set((state) => {
                            // console.log(`remove component`, { draftId, benefitPlanComponent })
                            const updatedBenefitPlans = state.benefitPlans.map((obj) => {
                                if (obj.draftId === draftId) {
                                    return {
                                        ...obj,
                                        benefitPlanComponents: obj.benefitPlanComponents.filter(
                                            (bpc) => bpc.bnftPlanCompHistFactKey !== benefitPlanComponent.bnftPlanCompHistFactKey && bpc.benefitPlanCompKey !== benefitPlanComponent.benefitPlanCompKey
                                        ),
                                    };
                                }
                                return obj;
                            });
                            return { ...state, benefitPlans: updatedBenefitPlans };
                        }),
                    //rider
                    addBenefitPlanRider: ({ draftId, benefitPlanRider }) =>
                        set((state) => {
                            const benefitPlans = state.benefitPlans.map((obj) => {
                                if (obj.draftId === draftId) {
                                    const isIncluded = obj.chosenBenefitPlanRiders?.some(
                                        (bpr) => bpr.bnftPlanRiderHistFactKey === benefitPlanRider.bnftPlanRiderHistFactKey && bpr.benefitPlanRiderKey === benefitPlanRider.benefitPlanRiderKey
                                    );
                                    if (isIncluded) {
                                        return obj;
                                    }
                                    return { ...obj, chosenBenefitPlanRiders: [...obj.chosenBenefitPlanRiders, benefitPlanRider] };
                                }
                                return obj;
                            });
                            return { ...state, benefitPlans };
                        }),
                    removeBenefitPlanRider: ({ draftId, benefitPlanRider }) =>
                        set((state) => {
                            // console.log(`remove component`, { draftId, benefitPlanComponent })
                            const benefitPlans = state.benefitPlans.map((obj) => {
                                if (obj.draftId === draftId) {
                                    return {
                                        ...obj,
                                        chosenBenefitPlanRiders: obj.chosenBenefitPlanRiders.filter(
                                            (bpr) => bpr.bnftPlanRiderHistFactKey !== benefitPlanRider.bnftPlanRiderHistFactKey && bpr.benefitPlanRiderKey !== benefitPlanRider.benefitPlanRiderKeyy
                                        ),
                                    };
                                }
                                return obj;
                            });
                            return { ...state, benefitPlans };
                        }),
                }),
                syncOptions
            ),
            persistOptions
        )
    )
);

const useBenefitPlanMultiStepFormStore = create(
    devtools(
        persist(
            sync(
                (set, get) => ({
                    activeStep: 1,
                    ridersInTemplate: [],
                    setActiveStep: (activeStep) => set((state) => {
                        return { ...state, activeStep }
                    }),
                    setRidersInTemplate: (riders) => set((state) => {
                        return { ...state, ridersInTemplate: riders }
                    })

                }),
                multiStepFormStoreSyncOptions
            ),
            multiStepFormPersistOptions
        )
    )
)
export { useBenefitPlanStore, useBenefitPlanMultiStepFormStore };
